import * as moment from "moment";
import "./veriCalendar.scss";

class CalendarComponentController implements angular.IComponentController {
    loading: boolean = true;

    selectedDate: Date;

    selectableDates: Date[];

    onDateChanged: (args: { date: Date }) => void;

    dateFilterFn: (date: Date) => void;

    $onInit() {
        this.dateFilterFn = (date) => {
            for (let i = 0; i < this.selectableDates.length; i++) {
                if (moment(this.selectableDates[i]).isSame(date, "day")) {
                    return true;
                }
            }

            return false;
        }
    }

    $onChanges() {
        if (this.selectableDates) {
            this.loading = false;
        }
    }

    dateChanged() {
        if (this.onDateChanged) {
            this.onDateChanged({ date: this.selectedDate });
        }
    }
}



export class CalendarComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            selectedDate: "<",

            selectableDates: "<",

            onDateChanged: "&"
        };

        this.controller = CalendarComponentController;
        this.template = require("./veriCalendar.html");
    }
}
